import axios from "axios";
import { utilityServicesPath} from "../../Constants";

export default class UtilityNewsService {
    static getFormData(selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        return formData;
    }

    static async getPage() {
        return axios.get(`${utilityServicesPath}/user/news/page`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getById(id) {
        return axios.get(`${utilityServicesPath}/user/news/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getThemeUser() {
        return axios.get(`${utilityServicesPath}/user/theme-news`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getFilter(themeNewsId, page) {
        return axios.get(`${utilityServicesPath}/user/news/filter?themeNewsId=${themeNewsId}&page=${page}&pageSize=5`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async get(pageNumber, pageSize, search, themeNewsId, isRelevant, isPopular) {
        const params = {
            page: pageNumber,
            pageSize: pageSize,
            search: search,
            themeNewsId: themeNewsId,
            isRelevant: isRelevant,
            isPopular: isPopular
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        return axios.get(`${utilityServicesPath}/admin/news/filter?${queryString}`);
    }

    static async add(data, file, themeNewsId) {
        const params = {
            text: data?.text,
            description: data?.description,
            themeNewsId: themeNewsId,
            priorityRelevant: data?.priorityRelevant,
            priorityPopular: data?.priorityPopular,
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        return await axios.post(`${utilityServicesPath}/admin/news?${queryString}`, UtilityNewsService.getFormData(file));
    }

    static async update(data, id) {
        return await axios.put(`${utilityServicesPath}/admin/news/${id}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        return await axios.delete(`${utilityServicesPath}/admin/news/${id}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async getTheme() {
        return axios.get(`${utilityServicesPath}/admin/theme-news`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async addTheme(data) {
        return await axios.post(`${utilityServicesPath}/admin/theme-news`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async updateTheme(data, id) {
        return await axios.put(`${utilityServicesPath}/admin/theme-news/${id}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteTheme(id) {
        return await axios.delete(`${utilityServicesPath}/admin/theme-news/${id}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }
}